import Checkbox from '../../../common/Checkbox/Checkbox';
import DatePicker from '../../../common/DatePicker/DatePicker';
import Dropdown from '../../../common/Dropdown/Dropdown';
import Input from '../../../common/Input/Input';
import Text from '../../../common/Text/Text';
import TextArea from '../../../common/TextArea/TextArea';
import Time from '../../../common/Time/Time';
import ToggleSwitch from '../../../common/ToggleSwitch/ToggleSwitch';
import './Inputs.scss';

const LABEL = 'Label';

const dropdownOptions = [
  { label: 'Option One', value: 'one', disabled: false },
  { label: 'Option Two', value: 'two', disabled: false },
  { label: 'Option Three', value: 'three', disabled: false },
];

const Inputs = () => {
  /* v8 ignore next -- @preserve */
  const mockOnChange = () => {};
  /* v8 ignore next -- @preserve */
  const mockDateChange = () => {};
  /* v8 ignore next -- @preserve */
  const mockChange = () => {};

  return (
    <div className="inputs">
      <div className="segment">
        <div className="title">
          <Text type="subheader">Input field</Text>
        </div>
        <div className="content">
          <Input label={LABEL} inputId="1-1" onChange={mockOnChange} placeholder="Placeholder" />
          <Input
            label={LABEL}
            inputId="1-2"
            onChange={mockOnChange}
            placeholder="Placeholder"
            autoFocus
          />
          <Input label={LABEL} inputId="1-3" onChange={mockOnChange} value="..." />
          <Input
            label={LABEL}
            inputId="1-4"
            onChange={mockOnChange}
            value="..."
            error="Error message"
          />
          <Input label={LABEL} inputId="1-5" onChange={mockOnChange} value="..." disabled />
          <Input
            label={LABEL}
            inputId="1-6"
            onChange={mockOnChange}
            placeholder="Placeholder"
            disabled
          />
          <Input
            label={LABEL}
            inputId="1-7"
            onChange={mockOnChange}
            placeholder="Placeholder"
            required
          />
        </div>
      </div>
      <div className="segment">
        <div className="title">
          <Text type="subheader">Input field - phone</Text>
        </div>
        <div className="content">
          <Input
            label={LABEL}
            inputId="2-1"
            onChange={mockOnChange}
            placeholder="Placeholder"
            countryCode="+44"
          />
          <Input
            label={LABEL}
            inputId="2-2"
            onChange={mockOnChange}
            placeholder="Placeholder"
            autoFocus
            countryCode="+44"
          />
          <Input
            label={LABEL}
            inputId="2-3"
            onChange={mockOnChange}
            value="..."
            countryCode="+44"
          />
          <Input
            label={LABEL}
            inputId="2-4"
            onChange={mockOnChange}
            value="..."
            error="Error message"
            countryCode="+44"
          />
          <Input
            label={LABEL}
            inputId="2-5"
            onChange={mockOnChange}
            value="..."
            disabled
            countryCode="+44"
          />
          <Input
            label={LABEL}
            inputId="2-6"
            onChange={mockOnChange}
            placeholder="Placeholder"
            disabled
            countryCode="+44"
          />
          <Input
            label={LABEL}
            inputId="2-7"
            onChange={mockOnChange}
            placeholder="Placeholder"
            required
            countryCode="+44"
          />
        </div>
      </div>
      <div className="segment">
        <div className="title">
          <Text type="subheader">Input field - icon</Text>
        </div>
        <div className="content">
          <Input
            label={LABEL}
            inputId="3-1"
            onChange={mockOnChange}
            placeholder="Placeholder"
            rightIconName="Circle"
          />
          <Input
            label={LABEL}
            inputId="3-2"
            onChange={mockOnChange}
            placeholder="Placeholder"
            autoFocus
            rightIconName="Circle"
          />
          <Input
            label={LABEL}
            inputId="3-3"
            onChange={mockOnChange}
            value="..."
            rightIconName="Circle"
          />
          <Input
            label={LABEL}
            inputId="3-4"
            onChange={mockOnChange}
            value="..."
            error="Error message"
            rightIconName="Circle"
          />
          <Input
            label={LABEL}
            inputId="3-5"
            onChange={mockOnChange}
            value="..."
            disabled
            rightIconName="Circle"
          />
          <Input
            label={LABEL}
            inputId="3-6"
            onChange={mockOnChange}
            placeholder="Placeholder"
            disabled
            rightIconName="Circle"
          />
          <Input
            label={LABEL}
            inputId="3-7"
            onChange={mockOnChange}
            placeholder="Placeholder"
            required
            rightIconName="Circle"
          />
        </div>
      </div>
      <div className="segment">
        <div className="title">
          <Text type="subheader">Input field - textarea</Text>
        </div>
        <div className="content">
          <TextArea label={LABEL} inputId="4-1" onChange={mockOnChange} placeholder="Placeholder" />
          <TextArea label={LABEL} inputId="4-2" onChange={mockOnChange} placeholder="Placeholder" />
          <TextArea label={LABEL} inputId="4-3" onChange={mockOnChange} value="..." />
          <TextArea
            label={LABEL}
            inputId="4-4"
            onChange={mockOnChange}
            value="..."
            error="Error message"
          />
          <TextArea label={LABEL} inputId="1-5" onChange={mockOnChange} value="..." disabled />
          <TextArea
            label={LABEL}
            inputId="4-6"
            onChange={mockOnChange}
            placeholder="Placeholder"
            disabled
          />
          <TextArea
            label={LABEL}
            inputId="4-7"
            onChange={mockOnChange}
            placeholder="Placeholder"
            required
          />
        </div>
      </div>
      <div className="segment">
        <div className="title">
          <Text type="subheader">Input field - dropdown</Text>
        </div>
        <div className="content">
          <Dropdown
            options={dropdownOptions}
            selectedOptions={[]}
            label={LABEL}
            inputId="5-1"
            onChange={mockOnChange}
            placeholder="Placeholder"
          />
          <Dropdown
            options={dropdownOptions}
            selectedOptions={[]}
            label={LABEL}
            inputId="5-2"
            onChange={mockOnChange}
            placeholder="Placeholder"
          />
          <Dropdown
            options={dropdownOptions}
            selectedOptions={[]}
            label={LABEL}
            inputId="5-3"
            onChange={mockOnChange}
            placeholder="Placeholder"
            value="..."
          />
          <Dropdown
            options={dropdownOptions}
            selectedOptions={[]}
            label={LABEL}
            inputId="5-4"
            onChange={mockOnChange}
            placeholder="Placeholder"
            value="..."
            error="Error message"
          />
          <Dropdown
            options={dropdownOptions}
            selectedOptions={[]}
            label={LABEL}
            inputId="5-5"
            onChange={mockOnChange}
            placeholder="Placeholder"
            value="..."
            disabled
          />

          <Dropdown
            options={dropdownOptions}
            selectedOptions={[]}
            label={LABEL}
            inputId="5-6"
            onChange={mockOnChange}
            placeholder="Placeholder"
            disabled
          />

          <Dropdown
            options={dropdownOptions}
            selectedOptions={[]}
            label={LABEL}
            inputId="5-7"
            onChange={mockOnChange}
            placeholder="Placeholder"
            required
          />

          <Dropdown
            options={dropdownOptions}
            selectedOptions={[]}
            label={LABEL}
            inputId="5-7"
            onChange={mockOnChange}
            placeholder="Placeholder drop upwards"
            dropUpwards
          />
          <Dropdown
            options={dropdownOptions}
            selectedOptions={[]}
            label={LABEL}
            inputId="5-7"
            onChange={mockOnChange}
            placeholder="Placeholder"
            initiallyOpen
          />
        </div>
      </div>
      <div className="segment">
        <div className="title">
          <Text type="subheader">Input field - icon button</Text>
        </div>
        <div className="content">
          <Input
            label={LABEL}
            inputId="6-1"
            onChange={mockOnChange}
            placeholder="Placeholder"
            iconButtonName="CircleUser"
          />
          <Input
            label={LABEL}
            inputId="6-2"
            onChange={mockOnChange}
            placeholder="Placeholder"
            autoFocus
            iconButtonName="CircleUser"
          />
          <Input
            label={LABEL}
            inputId="6-3"
            onChange={mockOnChange}
            value="..."
            iconButtonName="CircleUser"
          />
          <Input
            label={LABEL}
            inputId="6-4"
            onChange={mockOnChange}
            value="..."
            error="Error message"
            iconButtonName="CircleUser"
          />
          <Input
            label={LABEL}
            inputId="6-5"
            onChange={mockOnChange}
            value="..."
            disabled
            iconButtonName="CircleUser"
          />
          <Input
            label={LABEL}
            inputId="6-6"
            onChange={mockOnChange}
            placeholder="Placeholder"
            disabled
            readOnly
            iconButtonName="CircleUser"
          />
          <Input
            label={LABEL}
            inputId="6-7"
            onChange={mockOnChange}
            placeholder="Placeholder"
            required
            iconButtonName="CircleUser"
          />
        </div>
      </div>
      <div className="segment">
        <div className="title">
          <Text type="subheader">Input field - date picker</Text>
        </div>
        <div className="content">
          <DatePicker
            label={LABEL}
            inputId="7-1"
            initialPlaceholder="Placeholder"
            setDate={mockDateChange}
          />
          <DatePicker
            label={LABEL}
            inputId="7-2"
            initialPlaceholder="Placeholder"
            setDate={mockDateChange}
          />
          <DatePicker
            label={LABEL}
            inputId="7-3"
            date={new Date(2023, 1, 20)}
            setDate={mockDateChange}
          />
          <DatePicker
            label={LABEL}
            inputId="7-4"
            date={new Date(2023, 1, 20)}
            setDate={mockDateChange}
            error="Error message"
          />
          <DatePicker
            label={LABEL}
            inputId="7-5"
            date={new Date(2023, 1, 20)}
            disabled
            setDate={mockDateChange}
          />
          <DatePicker
            label={LABEL}
            inputId="7-6"
            initialPlaceholder="Placeholder"
            disabled
            setDate={mockDateChange}
          />
          <DatePicker
            label={LABEL}
            inputId="7-7"
            initialPlaceholder="Placeholder"
            setDate={mockDateChange}
            showTodayTomorrow
          />
        </div>
      </div>
      <div className="segment">
        <div className="title">
          <Text type="subheader">Input field - time</Text>
        </div>
        <div className="content">
          <Time
            label={LABEL}
            inputId="7-1"
            placeholder="Placeholder"
            setTimeInput={mockDateChange}
          />
          <Time
            label={LABEL}
            inputId="7-2"
            placeholder="Placeholder"
            setTimeInput={mockDateChange}
          />
          <Time
            label={LABEL}
            inputId="7-3"
            placeholder="Placeholder"
            setTimeInput={mockDateChange}
          />
          <Time
            label={LABEL}
            inputId="7-4"
            placeholder="Placeholder"
            setTimeInput={mockDateChange}
            timeValueProp="22:22"
          />
          <Time label={LABEL} inputId="7-5" setTimeInput={mockDateChange} disabled />
          <Time label={LABEL} inputId="7-6" setTimeInput={mockDateChange} error="Error message" />
          <Time
            label={LABEL}
            inputId="7-7"
            timeValueProp="22:22"
            setTimeInput={mockDateChange}
            disabled
          />
        </div>
      </div>
      <div className="segment">
        <div className="title">
          <Text type="subheader">Input field - multi select dropdown</Text>
        </div>
        <div className="content">
          <Dropdown
            options={dropdownOptions}
            selectedOptions={[]}
            label={LABEL}
            inputId="8-1"
            onChange={mockOnChange}
            multiSelect
            placeholder="Placeholder"
          />
          <Dropdown
            options={dropdownOptions}
            selectedOptions={[]}
            label={LABEL}
            inputId="8-2"
            onChange={mockOnChange}
            placeholder="Placeholder"
            multiSelect
          />
          <Dropdown
            options={dropdownOptions}
            selectedOptions={[]}
            label={LABEL}
            inputId="8-3"
            onChange={mockOnChange}
            placeholder="Placeholder"
            value="..."
            multiSelect
          />
          <Dropdown
            options={dropdownOptions}
            selectedOptions={[]}
            label={LABEL}
            inputId="8-4"
            onChange={mockOnChange}
            placeholder="Placeholder"
            value="..."
            error="Error message"
            multiSelect
          />
          <Dropdown
            options={dropdownOptions}
            selectedOptions={[]}
            label={LABEL}
            inputId="8-5"
            onChange={mockOnChange}
            placeholder="Placeholder"
            value="..."
            disabled
            multiSelect
          />

          <Dropdown
            options={dropdownOptions}
            selectedOptions={[]}
            label={LABEL}
            inputId="8-6"
            onChange={mockOnChange}
            placeholder="Placeholder"
            disabled
            multiSelect
          />

          <Dropdown
            options={dropdownOptions}
            selectedOptions={[]}
            label={LABEL}
            inputId="8-7"
            onChange={mockOnChange}
            placeholder="Placeholder"
            required
            multiSelect
          />

          <Dropdown
            options={dropdownOptions}
            selectedOptions={[]}
            label={LABEL}
            inputId="8-8"
            onChange={mockOnChange}
            placeholder="Placeholder drop upwards"
            dropUpwards
            multiSelect
          />
          <Dropdown
            options={dropdownOptions}
            selectedOptions={[]}
            label={LABEL}
            inputId="8-9"
            onChange={mockOnChange}
            placeholder="Placeholder"
            initiallyOpen
            multiSelect
          />
        </div>
      </div>
      <div className="segment">
        <div className="title">
          <Text type="subheader">Toggle</Text>
        </div>
        <div className="content">
          <ToggleSwitch isChecked={false} inputId="1-1" name="1-1" onChange={mockChange} />
          <ToggleSwitch isChecked={false} inputId="1-2" name="1-2" onChange={mockChange} />
          <ToggleSwitch isChecked={false} inputId="1-3" name="1-3" onChange={mockChange} />
          <ToggleSwitch isChecked inputId="1-4" name="1-4" onChange={mockChange} />
          <ToggleSwitch isChecked={false} inputId="1-5" name="1-5" onChange={mockChange} disabled />
          <ToggleSwitch isChecked inputId="1-6" name="1-6" onChange={mockChange} disabled />
          <ToggleSwitch isChecked={false} inputId="1-7" name="1-7" onChange={mockChange} />
        </div>
      </div>
      <div className="segment">
        <div className="title">
          <Text type="subheader">Toggle - label</Text>
        </div>
        <div className="content">
          <ToggleSwitch
            label="Label"
            isChecked={false}
            inputId="2-1"
            name="2-1"
            onChange={mockChange}
          />
          <ToggleSwitch
            label="Label"
            isChecked={false}
            inputId="2-2"
            name="2-2"
            onChange={mockChange}
          />
          <ToggleSwitch
            label="Label"
            isChecked={false}
            inputId="2-3"
            name="2-3"
            onChange={mockChange}
          />
          <ToggleSwitch label="Label" isChecked inputId="2-4" name="2-4" onChange={mockChange} />
          <ToggleSwitch
            label="Label"
            isChecked={false}
            inputId="2-5"
            name="2-5"
            onChange={mockChange}
            disabled
          />
          <ToggleSwitch
            label="Label"
            isChecked
            inputId="2-6"
            name="2-6"
            onChange={mockChange}
            disabled
          />
          <ToggleSwitch
            label="Label"
            isChecked={false}
            inputId="2-7"
            name="2-7"
            onChange={mockChange}
          />
        </div>
      </div>
      <div className="segment">
        <div className="title">
          <Text type="subheader">Checkbox</Text>
        </div>
        <div className="content">
          <Checkbox isChecked={false} inputId="3-1" onChange={mockChange} />
          <Checkbox isChecked={false} inputId="3-2" onChange={mockChange} />
          <Checkbox isChecked={false} inputId="3-3" onChange={mockChange} />
          <Checkbox isChecked inputId="3-4" onChange={mockChange} />
          <Checkbox isChecked={false} inputId="3-5" onChange={mockChange} disabled />
          <Checkbox isChecked inputId="3-6" onChange={mockChange} disabled />
          <Checkbox isChecked={false} inputId="3-7" onChange={mockChange} />
        </div>
      </div>
      <div className="segment">
        <div className="title">
          <Text type="subheader">Checkbox - label</Text>
        </div>
        <div className="content">
          <Checkbox label="Label" isChecked={false} inputId="4-1" onChange={mockChange} />
          <Checkbox label="Label" isChecked={false} inputId="4-2" onChange={mockChange} />
          <Checkbox label="Label" isChecked={false} inputId="4-3" onChange={mockChange} />
          <Checkbox label="Label" isChecked inputId="4-4" onChange={mockChange} />
          <Checkbox label="Label" isChecked={false} inputId="4-5" onChange={mockChange} disabled />
          <Checkbox label="Label" isChecked inputId="4-6" onChange={mockChange} disabled />
          <Checkbox label="Label" isChecked={false} inputId="4-7" onChange={mockChange} />
        </div>
      </div>
      <div className="segment">
        <div className="title">
          <Text type="subheader">Checkbox - small</Text>
        </div>
        <div className="content">
          <Checkbox small isChecked={false} inputId="4-1" onChange={mockChange} />
          <Checkbox small isChecked={false} inputId="4-2" onChange={mockChange} />
          <Checkbox small isChecked={false} inputId="4-3" onChange={mockChange} />
          <Checkbox small isChecked inputId="4-4" onChange={mockChange} />
          <Checkbox small isChecked={false} inputId="4-5" onChange={mockChange} disabled />
          <Checkbox small isChecked inputId="4-6" onChange={mockChange} disabled />
          <Checkbox small isChecked={false} inputId="4-7" onChange={mockChange} />
        </div>
      </div>
    </div>
  );
};

export default Inputs;
